import { useState } from "react";
import { LibraryScreen } from "./screens/LibraryScreen.js";
import { ReplayScreen } from "./screens/ReplayScreen.js";
import type { Replay } from "./types.js";

export function App() {
  const [replays, setReplays] = useState<Replay[]>([]);
  const [open, setOpen] = useState<Replay | null>(null);

  if (open) {
    return <ReplayScreen replay={open} onExit={() => setOpen(null)} />;
  }
  return (
    <LibraryScreen
      replays={replays}
      onLoaded={setReplays}
      onOpen={(r) => setOpen(r)}
    />
  );
}
